import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import jwtInterceptor from '../service/jwtInterceptor';
import moment from 'moment/moment';
import {useApplication} from '../hooks/UseApplication';
import {API_URL} from '@utils/constants';
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import {Chip} from "@mui/material";
import Switch from '@mui/material/Switch';
import {userService} from '../service/UserService';
import {getUserType, getUserTypeLabel, UserType} from "../service/Enums";
import {AppCustomConfirmationDialog} from "./AppCustomConfirmationDialog";
import {useToast} from "../Context/ToastContext";

function TableRowUser({row, keyIndex, onEdit}) {
    const {user, logout} = useApplication();
    const toaster = useToast();
    const [userToDelete, setUserToDelete] = React.useState(null);
    const source = row?._source || row || {};
    const rowUser = row?.userDetails || source;
    const sourceId = source.id || source._id;
    const currentUserId = user?.id || user?._id;
    const [isActive, setIsActive] = React.useState(source.active !== false);

    const deleteUser = async () => {
        if (userToDelete) {
            try {
                await jwtInterceptor.delete(`${API_URL}/user?id=${sourceId}`);
                setUserToDelete(null);
                toaster.notifySuccess("Utilisateur supprimé avec succès.");
                if (sourceId === currentUserId) {
                    await logout();
                    return;
                }
                window.location.reload(false);
            } catch (error) {
                toaster.notifyError("Impossible de supprimer l'utilisateur.");
            }
        }
    }

    const handleEdit = (e) => {
        e.stopPropagation();
        if (row) {
            onEdit(row);
        }
    };

    const handleToggleActive = async (event) => {
        event.stopPropagation();
        const nextActive = !isActive;
        try {
            await userService.setActive(sourceId, nextActive);
            setIsActive(nextActive);
            toaster.notifySuccess(nextActive ? "Utilisateur activé." : "Utilisateur désactivé.");
        } catch (error) {
            toaster.notifyError("Impossible de modifier le statut de l'utilisateur.");
        }
    };

    if (!row) {
        return null;
    }

    return (
        <tr sx={{"& > *": {borderBottom: "unset"}}} key={keyIndex}
            style={keyIndex % 2 === 0 ? {backgroundColor: "", width: "100%", cursor: "pointer"} : {
                backgroundColor: "",
                width: "100%",
                cursor: "pointer"
            }}>
            <td className="px-2 align-middle" align="left">
                <Switch
                    checked={isActive}
                    onChange={handleToggleActive}
                    inputProps={{"aria-label": `${isActive ? "Désactiver" : "Activer"} ${source.username || "utilisateur"}`}}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#000000',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#000000',
                        },
                    }}
                />
            </td>
            <td className="px-2 align-middle" align="left">
                {source.username || ''}
            </td>
            <td className="px-2 align-middle" align="left">
                {source.name || ''}
            </td>
            <td className="px-2 align-middle" align="left">
                {source.firstname || ''}
            </td>
            <td className="px-2 align-middle" align="left">
                        <Chip sx={{background: getUserType(rowUser) === UserType.USER.value ? "#9e9e9e" : "#000000", color: "#fff",
                            textTransform: 'uppercase',
                        }}
                            label={getUserTypeLabel(rowUser) || 'Non défini'}/>
            </td>
            <td className="px-2 align-middle" align="left">
                {source.email || ''}
            </td>
            <td className="px-2 align-middle" align="left">
                {source.createdAt ? moment(source.createdAt).format("DD-MM-YYYY") : ''}
            </td>
            <td className="px-2">
                <IconButton aria-label="Modifier" size="small" onClick={handleEdit}>
                    <ModeEditIcon/>
                </IconButton>
                <IconButton aria-label="Supprimer" color="error" size="small" onClick={() => setUserToDelete(row)}>
                    <DeleteIcon/>
                </IconButton>
            </td>
            <AppCustomConfirmationDialog
                open={Boolean(userToDelete)}
                onClose={() => setUserToDelete(null)}
                onAccept={deleteUser}
                onDecline={() => setUserToDelete(null)}
                title="Confirmation de suppression"
                bodyMessage={`Êtes-vous sûr de vouloir supprimer l'utilisateur « ${source.username || ""} » ? Cette action est irréversible.`}
                acceptButtonText="Supprimer"
                declineButtonText="Annuler"
                acceptButtonColor="error"
            />
        </tr>
    );
}

export default TableRowUser;
